import { render } from "./uploadfileOD.vue?vue&type=template&id=0de69af8&scoped=true"
import script from "./uploadfileOD.vue?vue&type=script&lang=js"
export * from "./uploadfileOD.vue?vue&type=script&lang=js"

import "./uploadfileOD.vue?vue&type=style&index=0&id=0de69af8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de69af8"]])

export default __exports__